import type { Product } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

export interface ProductWithoutPreviewQuery {
  productWithoutPreview: Product
}

export interface ProductWithoutPreviewFilter {
  afterId: GQL_ID | null
  categoryId: GQL_ID | null
  xid: string
  name: string
}

export interface ProductWithoutPreviewVariables {
  filter: ProductWithoutPreviewFilter
}

const GQL_QUERY_PRODUCT_WITHOUT_PREVIEW = gql`
query($filter: ProductWithoutPreviewFilter) {
  productWithoutPreview(filter: $filter) {
    id
    xid
    name
    brand {
      name
    }
    pkg
    weight
    price
    eans {
      id
      ean
    }
  }
}
`

export const useFetchProductWithoutPreview = (filter: ProductWithoutPreviewFilter) => useQuery<ProductWithoutPreviewQuery,ProductWithoutPreviewVariables>(GQL_QUERY_PRODUCT_WITHOUT_PREVIEW, {
  variables: {
    filter
  },
  fetchPolicy: 'network-only'
})